import * as authriozation from './authriozation';
import * as originCase from './originCase';
import * as caseRule from './caseRule';
import * as courseware from './courseware';
import * as labelRelation from './labelRelation';
import * as research from './research';
import * as logger from './logger';

export const services = { authriozation, originCase, caseRule, courseware, labelRelation, research, logger };
